module.exports = __webpack_public_path__ + "static/media/pencil.01bd81a7.jpg";